import React from 'react';
import { Tab, Card, Row, Nav, Col } from 'react-bootstrap';
import { splitCamelCaseToString, alertSwal } from '~/utils/helpers';
import { Formik } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import FormTabManagerContent from './FormTabManagerContent';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { RequestBodyConverter } from '~/pages/CardSaga/RequestBodyConverter';
import isEmpty from 'lodash/isEmpty';
import SubmitResetButtonAndValidationError from '~/components/SubmitResetButtonAndValidationError';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import DisplayFormikState from '~/components/DisplayFormikState';
import { Loader } from '~/components/Loader';

function FormTabManager({ formSubmit }) {
    const {
        formGroups,
        cardInformation,
        schema,
        navTitles,
        setNavTitles,
        initialValues,
        setResetCount,
        apiValidationErrors,
        clearApiValidationErrors,
        allPictures,
        cardFrontRef,
        displayFormikState,
    } = useFormTab();
    const CardInformationComponent = cardInformation?.component;
    const dispatch = useDispatch();

    return (
        <>
            {isEmpty(initialValues) ? (
                <Loader />
            ) : (
                <Card>
                    <Card.Body>
                        <Formik
                            validationSchema={schema()}
                            onSubmit={async (values, formikBag) => {
                                try {
                                    formSubmit(values, formikBag);

                                    dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
                                } catch (error) {
                                    console.error(error);
                                }
                            }}
                            initialValues={{ ...initialValues }}
                            validateOnChange={false}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { values, handleSubmit, isSubmitting, resetForm, submitCount, isValid } = props;

                                return (
                                    <>
                                        <SubmitResetButtonAndValidationError
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                            navTitles={navTitles}
                                            setNavTitles={setNavTitles}
                                            apiValidationErrors={apiValidationErrors}
                                            clearApiValidationErrors={clearApiValidationErrors}
                                            isValid={isValid}
                                            submitCount={submitCount}
                                            alertSwal={alertSwal}
                                        />
                                        {CardInformationComponent && <CardInformationComponent values={values} />}
                                        {navTitles.length > 0 ? (
                                            <div style={{ display: 'block', width: '100%', padding: 10 }}>
                                                <Tab.Container
                                                    defaultActiveKey={formGroups[0].name}
                                                    transition={false}
                                                >
                                                    <Row
                                                        className={'mt-1 p-3'}
                                                        style={{
                                                            boxShadow: '1px 2px 3px #ededed',
                                                            border: '1px solid #d8d8d8',
                                                            borderRadius: '0.25rem',
                                                        }}
                                                    >
                                                        <Col sm={2}>
                                                            <Nav
                                                                variant="pills"
                                                                className="flex-column"
                                                            >
                                                                {navTitles.map((item, index) => {
                                                                    return (
                                                                        <Nav.Item key={index}>
                                                                            <Nav.Link eventKey={item.name}>
                                                                                {splitCamelCaseToString(item.name)}
                                                                                {item.hasError && (
                                                                                    <span>
                                                                                        <FontAwesomeIcon
                                                                                            className={
                                                                                                'text-danger fa-fw'
                                                                                            }
                                                                                            icon={faTriangleExclamation}
                                                                                        />
                                                                                    </span>
                                                                                )}
                                                                            </Nav.Link>
                                                                        </Nav.Item>
                                                                    );
                                                                })}
                                                            </Nav>
                                                        </Col>
                                                        <Col sm={10}>
                                                            <FormTabManagerContent props={props} />
                                                        </Col>
                                                    </Row>
                                                </Tab.Container>
                                            </div>
                                        ) : (
                                            <>
                                                {/* //this is for CLA */}
                                                <SubmitResetButtons
                                                    isSubmitting={isSubmitting}
                                                    handleSubmit={handleSubmit}
                                                    setResetCount={setResetCount}
                                                    resetForm={resetForm}
                                                    navTitles={navTitles}
                                                    setNavTitles={setNavTitles}
                                                />

                                                <DisplayFormikState
                                                    props={props}
                                                    displayFormikState={displayFormikState}
                                                />
                                            </>
                                        )}
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            )}
        </>
    );
}

FormTabManager.propTypes = {
    formSubmit: PropTypes.func.isRequired,
};
export default FormTabManager;
